module.exports = __webpack_public_path__ + "DINNextLTPro-BoldItalic.eot?f3d96e047d49bc253d4de4099111ae4f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldItalic.eot
// module id = 304
// module chunks = 0